import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  InputLabel,
} from "@mui/material";
import { useState } from "react";
import { ROUTE_PATH } from "../../helper/Constants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const B2B = () => {
  const { t } = useTranslation();

  const contacts = useSelector((state) => state.contacts.contacts);

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [pin, setPin] = useState("");
  const [interest, setInterest] = useState([]);

  const handleInterest = (value) => {
    const index = interest.indexOf(value);

    if (index > -1) {
      let newValue = [...interest];
      newValue.splice(index, 1);
      setInterest([...newValue]);
    } else {
      setInterest([...interest, value]);
    }
  };

  const handleSubmit = () => {
    const obj = {
      t: "B2B",
      n: fullName,
      h: phoneNumber,
      e: email,
      p: pin,
      i: interest,
    };
    window.open(
      ROUTE_PATH.WHATSAPP +
        contacts.b2b +
        "?text='" +
        JSON.stringify(obj) +
        "'",
      "_blank",
    );
  };

  return (
    <Box sx={{ padding: "10px", textAlign: "left" }}>
      <Box
        sx={{
          padding: "40px 0",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ display: "block" }}>
          <FormGroup>
            <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
              <InputLabel htmlFor="name">{t("b2b.fullname")} *</InputLabel>
              <Input
                required
                id="name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </FormControl>
            <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
              <InputLabel htmlFor="phone">{t("b2b.phone")} *</InputLabel>
              <Input
                required
                id="phone"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </FormControl>
            <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
              <InputLabel htmlFor="email">{t("b2b.email")} *</InputLabel>
              <Input
                required
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
              <InputLabel htmlFor="pin">{t("b2b.pin")} *</InputLabel>
              <Input
                required
                id="pin"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
              />
            </FormControl>
            <Box sx={{ textAlign: "left", paddingBottom: "15px" }}>
              {t("b2b.interest")} *
            </Box>
            <FormControl sx={{ display: "block" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={interest.indexOf("Incense") > -1}
                    value="Incense"
                    onChange={(e) => handleInterest(e.target.value)}
                  />
                }
                label={t("menu.incenses")}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={interest.indexOf("Spice") > -1}
                    value="Spice"
                    onChange={(e) => handleInterest(e.target.value)}
                  />
                }
                label={t("menu.spices")}
              />
            </FormControl>
            <Button
              disabled={
                !fullName ||
                !phoneNumber ||
                !email ||
                !pin ||
                interest.length === 0
              }
              variant="contained"
              onClick={handleSubmit}
            >
              {t("submit")}
            </Button>
          </FormGroup>
        </Box>
      </Box>
    </Box>
  );
};

export default B2B;
